import React, { forwardRef } from 'react';
import { cx } from '@emotion/css';
export const ErrorPage = forwardRef(({ className, testId, ...rest }, ref) => {
    return (React.createElement("span", { className: cx(className, 'ds-error-page'), "data-testid": testId, ref: ref, ...rest }, "There was an error"));
});
ErrorPage.displayName = 'ErrorPage';
